import { render, staticRenderFns } from "./snapshot.vue?vue&type=template&id=04babf56&scoped=true"
import script from "./snapshot.vue?vue&type=script&lang=js"
export * from "./snapshot.vue?vue&type=script&lang=js"
import style0 from "./snapshot.vue?vue&type=style&index=0&id=04babf56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04babf56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCardText,VTabItem})
